module.exports = __webpack_public_path__ + "static/61688785_1350174468466441_43101130686726144_n_optimized-602742cf6aad98d542e94f4c6e071ffd.jpg";